/* global yaCounter51424363 */

import scrollDepth from 'scroll-depth';
import router from '../router/router';

function start15SecTimeout() {
	clearTimeout($(window).data('timeout15Sec'));

	$(window).data('timeout15Sec', setTimeout(() => {
		ga('rbcspec.send', 'event', 'page', 'spent_on_page_15_sec');
		ga('send', 'event', 'page', 'spent_on_page_15_sec');
	}, 15000));
}

function virtualHit(path) {
	if (window.ga) {
		ga('set', 'page', path);
		ga('send', 'pageview', path);
		ga('rbcspec.set', 'page', path);
		ga('rbcspec.send', 'pageview', path);
	}

	if (window.yaCounter51424363) {
		yaCounter51424363.hit(path);
	}
}

function clearText(text) {
	return text.toString().trim().replace(/\s+/g, ' ');
}

scrollDepth({
	userTiming: false,
	pixelDepth: false,
	gtmOverride: true,
	eventHandler(data) {
		ga('send', 'event', data.eventCategory, data.eventAction, data.eventLabel, {nonInteraction: true});
		ga('rbcspec.send', 'event', data.eventCategory, data.eventAction, data.eventLabel, {nonInteraction: true});
	},
});

router.on('enter', (prevState, currentState) => {
	start15SecTimeout();

	if (!currentState.route) {
		return;
	}

	if (prevState.route) {
		virtualHit(currentState.route.generatePath({
			params: currentState.params,
		}));

		scrollDepth.reset();
	}
});

$('.header .header__logo-mitsubishi, .article__logo-mitsubishi').on('click', () => {
	ga('send', 'event', 'client link', 'logo header');
	ga('rbcspec.send', 'event', 'client link', 'click');
});

$('.header .header__logo-rbc, .article__logo-rbc').on('click', () => {
	ga('send', 'event', 'nav', 'rbc logo');
});

$('.js-footer-info-btn').on('click', () => {
	ga('send', 'event', 'nav', 'about project');
});

// main page
$('.js-main-popup-button').on('click', () => {
	ga('send', 'event', 'main', 'start click');
});

$('.small-circle-item').on('click', (e) => {
	let $element = $(e.currentTarget);
	let $elementName = clearText($element.find('.small-circle-item__title-content').text());

	ga('send', 'event', 'main', 'location click', $elementName);
});

$('.circle-item').on('click', (e) => {
	let $element = $(e.currentTarget);
	let $elementName = clearText($element.find('.circle-item__title').text());

	ga('send', 'event', 'main', 'location click', $elementName);
});

$('.page[data-page=home] .footer__social-link').on('click', (e) => {
	let socialName = $(e.currentTarget).data('type');

	ga('send', 'event', 'share', 'main page share', socialName);
});

$('.js-main-page-car').on('click', () => {
	ga('send', 'event', 'client link', 'main car click');
	ga('rbcspec.send', 'event', 'client link', 'click');
});

// article
$('.vjs-big-play-button', '.article__video').on('click', (e) => {
	let $button = $(e.currentTarget);
	let articleName = $button.closest('.article').find('.article__title').text();
	let videoName = `видео в статье '${articleName}'`;

	ga('send', 'event', 'article', 'video click', videoName);
});

$('.vjs-big-play-button', '.popup__video').on('click', (e) => {
	let $button = $(e.currentTarget);
	let articleName = clearText($button.closest('.page').find('.article__title').text());
	let videoName = `видео в галерее статьи '${articleName}'`;

	ga('send', 'event', 'article', 'gallery click', videoName);
});

$('.article__tab-pane').on('click', (e) => {
	let $tabPane = $(e.currentTarget);
	let $articleName = clearText($tabPane.closest('.article').find('.article__title').text());
	let $name = clearText($tabPane.text());

	ga('send', 'event', 'article', 'subarticle click', `${$articleName} || ${$name}`);
});

$('.js-article-fixed-car').on('click', () => {
	ga('send', 'event', 'client link', 'article car click');
	ga('rbcspec.send', 'event', 'client link', 'click');
});

// check popup.js to slideChange analytics

$('.article__social-link').on('click', (e) => {
	let socialName = $(e.currentTarget).data('type');

	ga('send', 'event', 'share', 'article share', socialName);
});

$('.article__article-link').on('click', (e) => {
	let articleName = clearText($(e.currentTarget).find('span').text());

	ga('send', 'event', 'article', 'see also top click', articleName);
});

// check article.js for scroll analytics
